<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<style>
  #app{ width:100%;}
  html,body,h1,h2,h3,h4,h5,h6,ul,ol,li,div,p,span,strong,a,img,em,i,dl,dt,dd,input,button,
article,aside,details,dialog,footer,header,mark,nav,section,time{ border:0; padding:0; margin:0; box-sizing:border-box;}
article,aside,details,figcaption,figure,footer,header,main,nav,section,summary { display: block;}
audio,canvas,progress,video { display: inline-block;  vertical-align: baseline;}

h1,h2,h3,h4,h5,h6{ font-weight: normal;}
a,a:hover{ text-decoration:none;}
ul li,dl,dt,dd{ list-style:none;}

body{ text-align: center; font: normal 12px/18px "Microsoft YaHei"; background: #fff;}
.wrap{ width: 1200px; margin: 0 auto; text-align: left;}

.font12{ font-size: 12px;}
.font14{ font-size: 14px;}
.font16{ font-size: 16px;}
.font18{ font-size: 18px;}
.font20{ font-size: 20px;}

.fl{ float: left;}
.fr{ float: right;}
.clear{ clear: both; overflow: hidden;}

.disBlock{ display: block;}
.disNone{ display: none;}
.disInBlock{ display: inline-block;}
.visBlock{ visibility: visible;}
.visNone{ visibility:hidden;}

.text-center{ text-align: center;}
.text-left{ text-align: left;}
.text-right{ text-align: right;}

.swiper-pagination-bullets{ bottom: 20px!important;}
.swiper-pagination-bullet-active{ opacity: 0.6!important; width: 20px!important;
 background: #000!important; border-radius: 5px!important;}
</style>



// WEBPACK FOOTER //
// src/App.vue